// userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    selectedUser: { id: '', name: '', email: '' },
  },
  reducers: {
    setSelectedUser: (state, action) => {
      state.selectedUser.id = action.payload.id;
      state.selectedUser.name = action.payload.name;
      state.selectedUser.email = action.payload.email;
      // Update other properties as needed
    },
  },
});

export const { setSelectedUser } = userSlice.actions;
export const selectSelectedUser = (state) => state.user.selectedUser;

export default userSlice.reducer;
